<template>
  <div >
    <!--Correspondence Address starts-->
    <div class="col-12 traveller-heading accordion-toggle">
    <div class="row">
      <div
        class="form-group col-lg-3 col-md-3 col-sm-3 mt-5 p-0"
        id="correspondenceAddress">
        <div class="form-inline">
          <h3 class="address">Correspondence Address</h3>
        </div>
      </div>

      <div class="col-lg-9 col-md-9 col-sm-9">
        <input
          checked
          type="checkbox"
          class="bgc-checkbox"
          id="check1"
          @click="showPermanentAddress()"/>
        <label class="checkbox-inline form-check-label" for="check1">
          <small class="check ml-2"
            >Permanent Address same as Correspondence Address</small>
        </label>
      </div>
    </div>
    </div>
    <!-- Address starts-->
    <div class="collapse show col-12 bgc-form-box">
      <div class="risk row">
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="Address*" :fixed="isFloat(correspondenceAddressData.address.value)">
            <input
              type="text"
              class="form-control"
              placeholder="Address*" 
              v-evolvews="correspondenceAddressData.address"
              v-model="correspondenceAddressData.address.value"
              v-on:keydown="addressOnly"
              :class="{'bgc-error-field':correspondenceAddressData.address.errorText !== ''}"
              maxlength="240"
            />
          </float-label>
          <span
            class="error-text"
            v-if="correspondenceAddressData.address.errorText!==''"
          >{{correspondenceAddressData.address.errorText}}</span>
        </div>
      </div>
      <!-- Address end-->
      <!-- Pincode starts-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="Pincode*" :fixed="isFloat(correspondenceAddressData.pinCode.value)">
            <input
              type="text"
              class="form-control"
              placeholder="Pincode*"
              v-on:keydown="onlyNumber"
              @blur="getAreaDetailsByPinCode()"
             v-evolvews="correspondenceAddressData.pinCode"
             v-model="correspondenceAddressData.pinCode.value"
             :class="{'bgc-error-field':correspondenceAddressData.pinCode.errorText !== ''}" 
             maxlength="6"
            />
          </float-label>
          <span
            class="error-text"
            v-if="correspondenceAddressData.pinCode.errorText!==''"
          >{{correspondenceAddressData.pinCode.errorText}}</span>
        </div>
      </div>
      <!-- Pincode end-->
      <!-- City starts-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="City*" :fixed="isFloat(correspondenceAddressData.city.value)">
            <input 
              type="text" 
              class="form-control"
              placeholder="City*"
              disabled 
              v-on:keydown="onlyCharSpace"
              v-evolvews="correspondenceAddressData.city"
              v-model="correspondenceAddressData.city.value"
              :class="{ 'bgc-error-field': correspondenceAddressData.city.errorText!=='' }" 
            />
          </float-label>
          <span
              class="error-text"
              v-if="correspondenceAddressData.city.errorText!==''"
            >{{ correspondenceAddressData.city.errorText}}</span>
        </div>
      </div>
      <!-- City end-->
      <!-- Area starts-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="Area*" :fixed="isFloat(correspondenceAddressData.area.value)">
            <select
              :disabled="areaList.length==0"
              v-evolvews="correspondenceAddressData.area"
              v-model="correspondenceAddressData.area.value"
              :class="{ 'bgc-error-field': correspondenceAddressData.area.errorText!==''}"
              class="form-control">
              <option disabled value='' v-if="correspondenceAddressData.area.value==''">Area*</option>
              <option disabled :value='null' v-if="correspondenceAddressData.area.value==null">Area*</option>
              <option v-for="area in areaList" :key="area.areaCode" :value="area.areaCode">{{area.areaName}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="correspondenceAddressData.area.errorText!==''"
          >{{correspondenceAddressData.area.errorText}}</span>
        </div>
      </div>
      <!-- Area end-->
      <!-- State starts-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="State*" :fixed="isFloat(correspondenceAddressData.state.value)">
            <input
              type="text"
              class="form-control"
              placeholder="State*"
              disabled
              v-evolvews="correspondenceAddressData.state"
              v-model="correspondenceAddressData.state.value"
              v-on:keydown="onlyCharSpace"
              :class="{ 'bgc-error-field': correspondenceAddressData.state.errorText!=='' }"
            />
          </float-label>
          <span
              class="error-text"
              v-if=" correspondenceAddressData.state.errorText!==''"
            >{{ correspondenceAddressData.state.errorText}}</span>
        </div>
      </div>
      <!-- State end-->
      <!-- E-mail starts-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="Email*" :fixed="isFloat(correspondenceAddressData.email.value)">
            <input
             type="text" 
             class="form-control" 
             placeholder="Email*"
             v-evolvews="correspondenceAddressData.email"
              @blur="checkValidationEmailAndMobile()"
             v-model="correspondenceAddressData.email.value"
             :class="{'bgc-error-field':correspondenceAddressData.email.errorText !== ''}" 
            />
            <span
            class="error-text"
            v-if="correspondenceAddressData.email.errorText!==''"
          >{{correspondenceAddressData.email.errorText}}</span>
          </float-label>
        </div>
      </div>
      <!-- E-mail end-->
      <!-- Mobile Number Code-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group" >
          <float-label label="Mobile Number*" :fixed="isFloat(correspondenceAddressData.mobileNumber.value)">
            <input
              type="text"
              class="form-control"
              placeholder="Mobile Number*"
              v-evolvews="correspondenceAddressData.mobileNumber"
              v-model="correspondenceAddressData.mobileNumber.value"
              @blur="checkValidationEmailAndMobile()"
              :class="{'bgc-error-field':correspondenceAddressData.mobileNumber.errorText !== ''}"
              maxlength="10"
            />
            <span
            class="error-text"
            v-if="correspondenceAddressData.mobileNumber.errorText!==''"
          >{{correspondenceAddressData.mobileNumber.errorText}}</span>
          </float-label>
        </div>
      </div>
      <!-- Mobile Number Code-->
      <!-- PAN Number Code-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="PAN Number" :fixed="isFloat(correspondenceAddressData.panNumber.value)">
            <input
              type="text"
              class="form-control pan-input" 
              placeholder="PAN Number"
              @change="resetPanText()" 
              v-on:keyup="alphaNumeric"
              @blur="checkIsPanValid()"
              v-evolvews="correspondenceAddressData.panNumber"
              v-model="correspondenceAddressData.panNumber.value"
              :class="{'bgc-error-field':correspondenceAddressData.panNumber.errorText !== ''}"
              maxlength="10"
            />
            <span
            class="error-text"
            v-if="correspondenceAddressData.panNumber.errorText!==''"
          >{{correspondenceAddressData.panNumber.errorText}}</span>
          </float-label>
          <span>
            <a
              href="#"
              class="add-wrapper bgc-links validate-pan collapsed"
              data-toggle="collapse"
              data-target="#validate_PAN"
              @click="validatePan()"
            >Validate PAN</a>
          </span>
        </div>
      </div>
      <!-- PAN Number Code-->
      </div>
    </div>
    <!--Correspondence Address end-->
    <!--Permanent Address start-->
    <div v-if="!hidePermanentAddress">
      <div class="row">
        <div
          class="form-group col-lg-12 col-md-12 col-sm-12 mt-5 pr-0"
          id="permanentAddress"
        >
          <h3 class="perAddress">Permanent Address</h3>
        </div>
      </div>
      <!-- Address starts-->
      <div class="collapse show col-12 bgc-form-box">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
            <float-label label="Address*" :fixed="isFloat(correspondenceAddressData.address.value)">
              <input
                type="text" 
                class="form-control" 
                placeholder="Address*" 
                v-evolvews="permanentAddressData.address"
                v-on:keydown="addressOnly"
                v-model="permanentAddressData.address.value"
                :class="{'bgc-error-field':permanentAddressData.address.errorText !== ''}"
                maxlength="240"
              />
              <span
            class="error-text"
            v-if="permanentAddressData.address.errorText!==''"
          >{{permanentAddressData.address.errorText}}</span>
            </float-label>
          </div>
        </div>
        <!-- Address end-->
        <!-- Pincode starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
            <float-label label="Pincode*" :fixed="isFloat(correspondenceAddressData.pinCode.value)">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Pincode*" 
                v-on:keydown="onlyNumber"
                maxlength="6"
                v-evolvews="permanentAddressData.pinCode"
                v-model="permanentAddressData.pinCode.value"
                :class="{'bgc-error-field':permanentAddressData.pinCode.errorText !== ''}"
              />
              <span
            class="error-text"
            v-if="permanentAddressData.pinCode.errorText!==''"
          >{{permanentAddressData.pinCode.errorText}}</span>
            </float-label>
          </div>
        </div>
        <!-- Pincode end-->
        <!-- City starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
            <float-label label="City*" :fixed="isFloat(correspondenceAddressData.city.value)">
              <input 
                type="text" 
                class="form-control" 
                placeholder="City*"
                disabled 
                v-evolvews="permanentAddressData.city"
                v-model="permanentAddressData.city.value"
                :class="{'bgc-error-field':permanentAddressData.city.errorText !== ''}"
                maxlength="6"
              />
              <span
            class="error-text"
            v-if="permanentAddressData.city.errorText!==''"
          >{{permanentAddressData.city.errorText}}</span>
            </float-label>
          </div>
        </div>
        <!-- City end-->
        <!-- Area starts-->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
          <float-label label="Area*" :fixed="isFloat(permanentAddressData.area.value)">
            <select
              :disabled="areaList.length==0"
              v-evolvews="permanentAddressData.area"
              v-model="permanentAddressData.area.value"
              :class="{ 'bgc-error-field': permanentAddressData.area.errorText!==''}"
              class="form-control">
              <option disabled value='' v-if="permanentAddressData.area.value==''">Area*</option>
              <option disabled :value='null' v-if="permanentAddressData.area.value==null">Area*</option>
              <option v-for="area in areaList" :key="area.areaCode" :value="area.areaCode">{{area.areaName}}</option>
            </select>
              <span
            class="error-text"
            v-if="permanentAddressData.area.errorText!==''"
          >{{permanentAddressData.area.errorText}}</span>
            </float-label>
          </div>
        </div>
        <!-- Area end-->
        <!-- State starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
            <float-label label="State*" :fixed="isFloat(permanentAddressData.state.value)">
              <input 
                type="text" 
                class="form-control" 
                placeholder="State*"
                disabled 
                v-evolvews="permanentAddressData.state"
                v-model="permanentAddressData.state.value"
                :class="{'bgc-error-field':permanentAddressData.state.errorText !== ''}"
                maxlength="80" 
              />
            </float-label>
            <span
            class="error-text"
            v-if="permanentAddressData.state.errorText!==''"
          >{{permanentAddressData.state.errorText}}</span>
          </div>
        </div>
        <!-- State end-->
      </div>
      <!--Permanent Address end-->
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import {reactive, computed, onMounted} from '@vue/composition-api';
import functions from '@/../../masters/functions.js';
// import Datepicker from "vuejs-datepicker";
export default {
  name: "CorrespondenceAddress",
  props:['hidePermanentAddress','correspondenceAddressData','permanentAddressData','areaList'],
  components: {
    FloatLabel,
  },
  setup(props,{parent,root}){
    function checkEncryption(obj) {
      if(obj.oldValue != obj.value || obj.oldValue == '' || obj.oldValue == null) {
          obj.skipEncryption = false;
          obj.skipEncryption = true;
      }
      else {
          obj.skipEncryption = true;
          obj.skipEncryption = false;
      }
    }
    //onMounted
    onMounted(()=>{
      resetPanText()
    });
    function resetPanText(){
        parent.resetPanText();
    }
    function validatePan(){
      if(props.correspondenceAddressData.panNumber.value && props.correspondenceAddressData.panNumber.errorText ==''){
        parent.validatePan();
      }
      else{
        let value = props.correspondenceAddressData.panNumber.value;
        parent.checkPan(value);
      }
    }
    function checkValidationEmailAndMobile(){
      root.$set(props.correspondenceAddressData.mobileNumber, 'stepsMandatory', true);
      root.$set(props.correspondenceAddressData.mobileNumber, 'skip', undefined);
      root.$set(props.correspondenceAddressData.email, 'stepsMandatory', true);
      root.$set(props.correspondenceAddressData.email, 'skip', undefined);
      if(props.correspondenceAddressData.email.value!=""){
        if(props.correspondenceAddressData.email.errorText==''){
          root.$set(props.correspondenceAddressData.mobileNumber, 'stepsMandatory', false);
          root.$set(props.correspondenceAddressData.mobileNumber, 'skip', true);
          if(props.correspondenceAddressData.mobileNumber.errorText == props.correspondenceAddressData.mobileNumber.errorMessage)
            root.$set(props.correspondenceAddressData.mobileNumber, 'errorText', '');
        }
      }
      if(props.correspondenceAddressData.mobileNumber.value!=""){
        if(props.correspondenceAddressData.mobileNumber.errorText==''){
          root.$set(props.correspondenceAddressData.email, 'stepsMandatory', false);
          root.$set(props.correspondenceAddressData.email, 'skip', true);
          if(props.correspondenceAddressData.email.errorText == props.correspondenceAddressData.email.errorMessage)
            root.$set(props.correspondenceAddressData.email, 'errorText', '');
        }
      }
    }
    function showPermanentAddress(){
      parent.showPermanentAddress();
    }
    function getAreaDetailsByPinCode(){
      parent.getAreaDetailsByPinCode();
    }
    function checkIsPanValid() {
      parent.checkIsPanValid()
    }
    const isFloat = functions.isFloat;
    const checkError = functions.checkError;
    const onlyNumber = functions.onlyNumber;
    const alphaNumeric = functions.alphaNumeric;
    const onlyCharSpace = functions.onlyCharSpace;
    const addressOnly = functions.addressOnly;
    return{
      showPermanentAddress,
      checkValidationEmailAndMobile,
      resetPanText,
      onlyNumber,
      checkError,
      alphaNumeric,
      isFloat,
      onlyCharSpace,
      getAreaDetailsByPinCode,
      addressOnly,
      checkEncryption,
      validatePan,
      checkIsPanValid
    }
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
.corrAddress {
  border-bottom: 1px solid #c7c7c7;
}
.address {
  border-bottom: none;
}
.perAddress {
  width: 99%;
}
.checkbox-inline {
  margin-top: 55px;
}
.pan-input{
  text-transform:uppercase;
}
::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder { /* Recent browsers */
  text-transform: none;
}
.bor-der1 {
  /* border-bottom: 1px solid #dedede; */
  border-bottom: 1px solid #c7c7c7;
  width: 99%;
  display: inline-grid;
  position: relative;
  /* left: 30px; */
  left: 0px;
  /* top: 5px; */
}
@media (max-width: 575px) {
  .checkbox-inline {
    margin-top: 0px;
    line-height: 20px;
    margin-bottom: 15px;
    font-size: 16px;
  }
}
</style>